import { render, staticRenderFns } from "./o-header.vue?vue&type=template&id=61e45692&"
import script from "./o-header.vue?vue&type=script&lang=js&"
export * from "./o-header.vue?vue&type=script&lang=js&"
import style0 from "./o-header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports